module.exports = __webpack_public_path__ + "e604d3c39ddb80ce3de3d23245cbf828.png";